<template>
  <a :href="data.href" class="app-button"
     :class="[data.more ? 'app-button--more':'',
     data.download ? 'app-button--download':'']"
     @click="$emit('click')" v-if="data.href" :target="blank">
    <span class="app-button__inner">
      <span class="app-button__text" v-if="data.text">{{ data.text }}</span>
      <span class="app-button__icon" :class="[data.download ? 'download' : '',
       data.more ? 'more' : '']"></span>
    </span>

  </a>
  <button class="app-button"
          :class="[data.more ? 'app-button--more':'',
     data.download ? 'app-button--download':'']"
          @click="$emit('click')" v-else>
    <span class="app-button__inner">
      <span class="app-button__text" v-if="data.text">{{ data.text }}</span>
      <span class="app-button__icon" :class="[data.download ? 'download' : '',
       data.more ? 'more' : '']"></span>
    </span>
    <app-loader v-show="loading"/>
  </button>
</template>

<script>
import AppLoader from '@/components/app-loader/app-loader.vue';

export default {
  name: 'AppButton',
  components: {
    AppLoader,
  },
  props: {
    data: Object,
    loading: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    blank() {
      if (this.data.download) return '_blank';
      return false;
    },
  },
};
</script>

<style lang="scss">
  @import "app-button";
</style>
